import PageHeader from 'components/pageHeader/PageHeader';
import { Trans } from 'react-i18next';
import PropertyEditPermissionInfo from '../common/PropertyEditPermissionInfo';
import usePropertySettingsInitData from '../usePropertySettingsInitData';
import PropertySettingsPricingManagementAlert from './PropertySettingsPricingManagementAlert';
import { PropertySettingsPricingTabStyledContainer } from './PropertySettingsPricingTab.styles';
import PriceRules from './sections/priceRules/PriceRules';
import PriceSettings from './sections/priceSettings/PriceSettings';

const PropertySettingsPricingTab = () => {
  const { property } = usePropertySettingsInitData();

  return (
    <>
      <PropertyEditPermissionInfo />
      <PageHeader
        title={
          <Trans
            i18nKey="pageProperty.pricing.tabTitle"
            values={{ propertyName: property?.name }}
            components={{ 1: <span className="green" /> }}
          />
        }
        noDivider
      />
      <PropertySettingsPricingTabStyledContainer>
        <PropertySettingsPricingManagementAlert />
        <PriceSettings />
        <div className="divider" />
        <PriceRules />
      </PropertySettingsPricingTabStyledContainer>
    </>
  );
};

export default PropertySettingsPricingTab;
